module.exports = __webpack_public_path__ + "static/test4-36f4963604e1a514dc57e711569c592d.png";